import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REOPEN_BRAND_CURATION_TASK_MUTATION } from '../graphql/mutations'
import { REOPEN_BRAND_CURATION_TASK } from '../redux/action-types'

const useReopenBrandCurationTaskMutation = () => {
  const dispatch = useDispatch()

  const { isUpdateLoading: isLoading, updateError: error } = useSelector(
    store => store.brandCurationTasks.brandCurationTask,
  )

  const mutate = useCallback(
    id =>
      apolloService.mutate({
        mutation: REOPEN_BRAND_CURATION_TASK_MUTATION,
        variables: { id },
        dispatch,
        action: REOPEN_BRAND_CURATION_TASK,
      }),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useReopenBrandCurationTaskMutation
